import React, { useState, useEffect } from 'react';
import ContactHeroSection from '../components/sections/ContactHeroSection';
import ContactInfoSection from '../components/sections/ContactInfoSection';

import { pagesData } from '../data/pagesData';

const sectionComponents: Record<string, React.ComponentType<any>> = {
  ContactHeroSection,
  ContactInfoSection,
};

const Contact: React.FC<{ language: 'ar' | 'en' }> = ({ language }) => {
  const [sections, setSections] = useState<any[]>([]);

  useEffect(() => {
    // محاولة قراءة البيانات من localStorage أولاً (للتغييرات المحدثة)
    const savedData = localStorage.getItem('pageData_contact');
    if (savedData) {
      try {
        const parsedData = JSON.parse(savedData);
        setSections(parsedData);
        console.log('Loaded updated data from localStorage');
      } catch (error) {
        console.error('Error parsing localStorage data:', error);
        // إذا فشل في قراءة localStorage، استخدم البيانات الأصلية
        setSections(pagesData.contact?.sections || []);
      }
    } else {
      // استخدام البيانات الأصلية من pagesData
      setSections(pagesData.contact?.sections || []);
    }
  }, []);

  return (
    <div className={`min-h-screen bg-gray-50 ${language === 'ar' ? 'font-cairo' : 'font-montserrat'}`} dir={language === 'ar' ? 'rtl' : 'ltr'}>
      {sections.map((section, idx) => {
        const SectionComponent = sectionComponents[section.type];
        if (!SectionComponent) return null;
        return (
          <SectionComponent key={idx} language={language} {...section.props} />
        );
      })}
    </div>
  );
};

export default Contact; 